// Shared notification utilities — used by PortalHeader and NotificationsPage

export function formatRelativeTime(iso) {
  if (!iso) return "";
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1)  return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24)  return `${hrs}h ago`;
  return new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short" });
}

export const NOTI_ICONS = {
  connection_request:  { icon: "pi-user-plus",     bg: "#eff6ff", color: "#1d4ed8" },
  connection_accepted: { icon: "pi-check-circle",  bg: "#f0fdf4", color: "#166534" },
  connection_rejected: { icon: "pi-times-circle",  bg: "#fef2f2", color: "#b91c1c" },
  prescription_upload: { icon: "pi-upload",        bg: "#f0fdf4", color: "#166534" },
  prescription_ready:  { icon: "pi-check-circle",  bg: "#f0fdf4", color: "#166534" },
  refill_request:      { icon: "pi-refresh",       bg: "#fef3c7", color: "#92400e" },
  refill_processed:    { icon: "pi-check",         bg: "#f0fdf4", color: "#166534" },
  refill_rejected:     { icon: "pi-times",         bg: "#fef2f2", color: "#b91c1c" },
  rx_upload_request:   { icon: "pi-file-check",    bg: "#f0fdf4", color: "#166534" },
  order_ready:         { icon: "pi-shopping-bag",  bg: "#ecfdf5", color: "#059669" },
  default:             { icon: "pi-bell",          bg: "var(--surface-bg)", color: "var(--text-secondary)" },
};

export function resolveRoute(n) {
  switch (n.noti_type) {
    case "refill_processed":
    case "refill_rejected":
    case "refill_request":
      return n.entity_id ? `/refills?filter_id=${n.entity_id}` : "/refills";

    case "prescription_ready":
      return n.entity_id ? `/prescriptions?filter_rx=${n.entity_id}` : "/prescriptions";

    case "prescription_upload":
      return n.entity_id ? `/upload?filter_upload=${n.entity_id}` : "/upload";

    case "rx_upload_request":
      return n.entity_id ? `/upload?filter_upload=${n.entity_id}` : "/upload";

    case "connection_request":
    case "connection_accepted":
    case "connection_rejected":
      return "/relatives";

    default:
      return n.entity_route || null;
  }
}
